import { Controller } from "@hotwired/stimulus"

/**
 * Region filter of the country list on the Passport page
 * Usage: data-controller="country-filter" on the container
 *        data-country-filter-target="button" on filter buttons
 *        data-country-filter-target="item" on country items
 *        data-country-filter-target="grid" on the grid container
 *        data-region="region-name" on both buttons and items
 */
export default class extends Controller<HTMLElement> {
  static targets = ["button", "item", "grid"]

  declare readonly buttonTargets: HTMLButtonElement[]
  declare readonly itemTargets: HTMLElement[]
  declare readonly gridTarget: HTMLElement
  declare readonly hasGridTarget: boolean

  filter(event: Event) {
    const button = event.currentTarget as HTMLButtonElement
    const region = button.dataset.region || "all"

    this.applyFilter(region)
  }

  private applyFilter(region: string) {
    // Update button styles
    this.buttonTargets.forEach(btn => {
      const btnRegion = btn.dataset.region || "all"
      const isActive = btnRegion === region

      btn.setAttribute("aria-pressed", String(isActive))
      if (isActive) {
        btn.classList.remove("btn-ghost")
        btn.classList.add("btn-primary")
      } else {
        btn.classList.remove("btn-primary")
        btn.classList.add("btn-ghost")
      }
    })

    // Filter items with animation
    this.itemTargets.forEach(item => {
      const itemRegion = item.dataset.region
      const show = region === "all" || itemRegion === region

      if (show) {
        item.classList.remove("hidden")
        // Add fade in animation
        item.style.opacity = "0"
        item.style.transform = "scale(0.9)"
        requestAnimationFrame(() => {
          item.style.transition = "opacity 150ms ease, transform 150ms ease"
          item.style.opacity = "1"
          item.style.transform = "scale(1)"
        })
      } else {
        item.classList.add("hidden")
      }
    })
  }
}
